export function recommendedSlider() {
    document.addEventListener('DOMContentLoaded', function () {

        const recommendedSlider = document.querySelectorAll('.blockRecommendedSlider');
        if (!recommendedSlider) return;

        recommendedSlider.forEach(slider => {
            const splideSlider = new window.splide(slider, {
                type: 'carousel',
                // autoplay: false,
                perPage: 3,
                perMove: 1,
                pagination: false,
                gap: '48px',
                breakpoints: {
                    1500: {
                        gap: '24px',
                    },
                    1400: {
                        perPage: 2,
                    },
                    991: {
                        perPage: 1,
                    },
                }
            });

            splideSlider.on('overflow', function (isOverflow) {
                splideSlider.options = {
                    arrows: isOverflow,
                    drag: isOverflow,
                };
            });
            splideSlider.mount();

        });





    });
}
